import { z } from 'zod';

import { PaymentId } from '../BrandedIds';
import { zodDateOrString } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const RepayMarkAsProcessedEvent = BaseLoanEvent.extend({
  type: z.literal('repayMarkAsProcessed'),
  paymentId: PaymentId,
  transactionDate: zodDateOrString,
  postDate: zodDateOrString,
  effectiveDate: zodDateOrString,
  processedDate: zodDateOrString.optional(),
});
export type RepayMarkAsProcessedEvent = z.infer<typeof RepayMarkAsProcessedEvent>;
